import { RouteType } from "types/RouteType";
import FleetDriverManagementWorkflowStore from "./FleetDriverManagementWorkflowStore";

const FleetDriverManagementWorkflowRoute: RouteType = {
  name: "Fleet Driver Management Workflow",
  path: "/workflows/fleet-driver-management",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Fleet & Driver Management",
      component: () => import("./FleetDriverManagementWorkflowHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./FleetDriverManagementWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.fleetDriverManagementWorkflowStore) {
      rootStore.fleetDriverManagementWorkflowStore = new FleetDriverManagementWorkflowStore(
        rootStore
      );
    }
    const store = rootStore.fleetDriverManagementWorkflowStore as FleetDriverManagementWorkflowStore;
    await store.loadInitialData();
    return true;
  },
};

export default FleetDriverManagementWorkflowRoute;